import React, { forwardRef, InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', type = 'text', ...props }, ref) => {
    const inputClasses = `
      w-full px-3 py-2
      text-sm text-slate-900
      bg-white
      border rounded-md
      transition-all duration-150
      placeholder:text-slate-400
      disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed
      focus:outline-none focus:ring-2 focus:ring-offset-0
      shadow-sm
      ${
        error
          ? 'border-danger-600 focus:border-danger-600 focus:ring-danger-200'
          : 'border-slate-300 focus:border-navy-600 focus:ring-navy-200'
      }
      ${type === 'number' ? 'font-mono' : ''}
      ${className}
    `.trim();

    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-slate-700 mb-1.5">
            {label}
            {props.required && <span className="text-danger-600 ml-1">*</span>}
          </label>
        )}
        <input ref={ref} type={type} className={inputClasses} {...props} />
        {error && (
          <p className="mt-1 text-sm text-danger-600" role="alert">
            {error}
          </p>
        )}
        {helperText && !error && (
          <p className="mt-1 text-xs text-slate-500">{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
